import { NavBar } from "../../../common/NavBar";
import * as React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { SitesScreen } from "./SitesScreen";
import { AddSiteButton } from "./AddSiteButton";
import BackdropLoadingScreen from "../../../common/BackdropLoadingScreen";
import Alert from "@mui/material/Alert";
import {
  cancelGroupSitesLoad,
  getIndividualGroup,
} from "./SitesPageUtils/getIndividualGroup";
import { AddGroupDialog } from "./AddGroupDialog";
import { Link } from "react-router-dom";
import { Dispatcher } from "../SiteAboutPage/SiteAboutPageUtils/siteAboutInterfaces";
import { fetchGroupTrees } from "../../../utils/fetchGroupTrees";
import { SitePageAlerts } from "./SitePageAlerts";
import { SearchCamerasDialog } from "./SearchCamerasDialog";
import { OrangeTextButton } from "../../../common/OrangeTextButton";
import { useSitesPageStore } from "./sitesPageStore/sitesPageStore";
import { useAppStore } from "../../../../appStore";
import { ImmixRemotelinkDialog } from "./ImmixRemotelinkDialog";

export const Sites = ({
  permissions,
  navBarCollapsed,
  setNavBarCollapsed,
}: {
  permissions: any;
  navBarCollapsed: boolean;
  setNavBarCollapsed: Dispatcher<boolean>;
}) => {
  const { userPermissions } = useAppStore();
  const { pathname } = useLocation();
  const isPatrol = pathname.includes("patrol");
  const groupTrees = useAppStore((s) =>
    isPatrol ? s.groupTreesPatrolOnly : s.groupTrees
  );
  const setGroupTrees = useAppStore((s) =>
    isPatrol ? s.setGroupTreesPatrolOnly : s.setGroupTrees
  );
  const {
    updatingBatchSize,
    batchSize,
    minimumResolutionHeight,
    immixRemotelinkDialogOpen,
  } = useSitesPageStore();
  const navigate = useNavigate();
  const clearGroupCountsCache = useSitesPageStore(
    (state) => state.clearGroupCountsCache
  );

  const [page, setPage] = React.useState(
    Number(localStorage.sitesTablePage) || 0
  );

  // Clear the group counts cache when the component mounts
  React.useEffect(() => {
    clearGroupCountsCache();
  }, [clearGroupCountsCache]);

  const [rowsPerPage, setRowsPerPage] = React.useState(
    Number(localStorage.sitesRowsPerPage) || 10
  );

  const [selected, setSelected] = React.useState([]);

  React.useEffect(() => {
    const raw = window.location.pathname.includes("patrol")
      ? localStorage.groupTreesPatrolOnly
      : localStorage.groupTrees;
    if (raw != null && raw !== "") {
      try {
        setGroupTrees(JSON.parse(raw));
      } catch {
        setGroupTrees([]);
      }
    }
  }, [window.location.pathname]);

  // Refetch when visiting Sites page when there's no cache so groups appear as soon as the API returns
  React.useEffect(() => {
    const raw = window.location.pathname.includes("patrol")
      ? localStorage.groupTreesPatrolOnly
      : localStorage.groupTrees;
    let currentGroupsTrees: any[] = [];
    if (raw != null && raw !== "") {
      try {
        currentGroupsTrees = JSON.parse(raw);
      } catch {
        currentGroupsTrees = [];
      }
    }
    if (!currentGroupsTrees[0]) {
      if (pathname.includes("patrol")) {
        fetchGroupTrees(navigate, "patrol");
      } else {
        fetchGroupTrees(navigate);
      }
    }
  }, [pathname, navigate, isPatrol]);

  const [selectedIndex, setSelectedIndex] = React.useState({
    level1: [],
    level2: [],
    level3: [],
    level4: [],
    level5: [],
    level6: [],
    // level7: [],
  });

  const [renderedRows, setRenderedRows] = React.useState([]);

  const [pageLoading, setPageLoading] = React.useState(false);

  const [currentTitle, setCurrentTitle] = React.useState("");

  const [searchBarValue, setSearchBarValue] = React.useState("");

  const [editedparentsGroupsList, setEditedParentGroupList] = React.useState(
    []
  );

  const [siteDeletedAlert, setSiteDeltedAlert] = React.useState(
    localStorage.siteDeletedAlert
  );

  const [groupAddedAlert, setGroupAddedAlert] = React.useState(false);

  const [backdropLoadingScreenOn, setBackdropLoadingScreenOn] =
    React.useState(false);

  const [siteBreadcrumbs, setSiteBreadcrumbs] = React.useState(
    // JSON.parse(localStorage.currentSiteBreadcrumbs)
    []
  );

  const [addGroupDialogOpen, setAddGroupDialogOpen] = React.useState(false);

  const [searchCamerasDialogOpen, setSearchCamerasDialogOpen] =
    React.useState(false);

  const [siteScreenAlerts, setSiteScreenAlerts] = React.useState({
    armGroupSuccess: false,
    disarmGroupSuccess: false,
    deployGroupSuccess: false,
  });

  const [siteScreenLoading, setSiteScreenLoading] = React.useState(false);

  const [editableGroupSelected, setEditableGroupSelected] =
    React.useState(false);

  const [selectedGroupListName, setSelectedGroupListName] = React.useState("");

  const { setSearchGroupId } = useSitesPageStore();

  React.useEffect(() => {
    cancelGroupSitesLoad();
    setPage(0);
    setRenderedRows([]);
    setSiteBreadcrumbs([]);
    setSelected([]);
    setEditableGroupSelected(false);
    setSelectedGroupListName("");
    setSearchBarValue("");
    localStorage.setItem("selectedGroupOrSiteId", "");
  }, [pathname]);

  React.useEffect(
    () => () => {
      localStorage.setItem("siteDeletedAlert", "false");
      localStorage.setItem("siteSearchBarValue", "");
    },
    []
  );

  React.useEffect(() => {
    if (
      (localStorage.navigatedFromSitesAboutPage === "true" &&
        localStorage.level0Click === "true") ||
      !localStorage.clickedId
    ) {
      setSiteBreadcrumbs([]);
      localStorage.setItem("navigatedFromSitesAboutPage", "false");
    } else if (
      localStorage.navigatedFromSitesAboutPage === "true" &&
      localStorage.level0Click === "false"
    ) {
      setPageLoading(true);
      localStorage.setItem("getIndividualGroupId", localStorage.clickedId);
      setSearchGroupId(localStorage.clickedId);
      getIndividualGroup(
        localStorage.clickedId,
        setRenderedRows,
        setPageLoading,
        setSiteBreadcrumbs,
        setSelected,
        setEditableGroupSelected,
        setSelectedGroupListName,
        navigate
      );
      localStorage.setItem("navigatedFromSitesAboutPage", "false");
    } else if (
      localStorage.navigatedFromSitesAboutPage === "false" &&
      localStorage.level0Click === "false" &&
      localStorage.siteJustDeleted !== "true"
    ) {
      setSelectedIndex(JSON.parse(localStorage.storedSelectedIndex));
      localStorage.setItem("getIndividualGroupId", localStorage.clickedId);
      setSearchGroupId(localStorage.clickedId);
      getIndividualGroup(
        localStorage.clickedId,
        setRenderedRows,
        setPageLoading,
        setSiteBreadcrumbs,
        setSelected,
        setEditableGroupSelected,
        setSelectedGroupListName,
        navigate
      );
      localStorage.setItem("navigatedFromSitesAboutPage", "false");
    }
  }, []);

  return (
    <div>
      <BackdropLoadingScreen openState={updatingBatchSize} />
      <div>
        <SitePageAlerts
          siteScreenAlerts={siteScreenAlerts}
          setSiteScreenAlerts={setSiteScreenAlerts}
        />
        {siteDeletedAlert === "true" && (
          <Alert
            onClose={() => {
              setSiteDeltedAlert("false");
              localStorage.setItem("siteDeletedAlert", "false");
            }}
          >
            Site deleted successfully!
          </Alert>
        )}
        {groupAddedAlert && (
          <Alert
            onClose={() => {
              setGroupAddedAlert(false);
            }}
          >
            {permissions?.view_empty_group ? (
              <>New Group added successfully!</>
            ) : (
              <>
                {" "}
                New Group added successfully! New Group will not appear in
                Parent Groups & Sites list until you&nbsp;
                <Link
                  to="/sites/addsite"
                  className="underline underline-offset-1"
                >
                  Add Site
                </Link>
                &nbsp; to the group.
              </>
            )}
          </Alert>
        )}
        {addGroupDialogOpen && (
          <AddGroupDialog
            addGroupDialogOpen={addGroupDialogOpen}
            setAddGroupDialogOpen={setAddGroupDialogOpen}
            setBackdropLoadingScreenOn={setBackdropLoadingScreenOn}
            setGroupAddedAlert={setGroupAddedAlert}
          />
        )}
        {searchCamerasDialogOpen && (
          <SearchCamerasDialog
            searchCamerasDialogOpen={searchCamerasDialogOpen}
            setSearchCamerasDialogOpen={setSearchCamerasDialogOpen}
            navigate={navigate}
          />
        )}
        {immixRemotelinkDialogOpen && <ImmixRemotelinkDialog />}
        <BackdropLoadingScreen openState={backdropLoadingScreenOn} />
        <BackdropLoadingScreen openState={siteScreenLoading} />
        <div className="bg-actuate-grey absolute w-screen h-screen">
          <div
            className={
              navBarCollapsed
                ? "absolute top-[10px] left-[75px] right-[1px] h-[19px]] bg-white"
                : "absolute top-[10px] left-[150px] right-[1px] h-[19px]] bg-white"
            }
          >
            <p className="font-black font-mulish text-[20px] p-3 indent-6">
              Sites
            </p>
          </div>
          <div>
            <SitesScreen
              searchBarValue={searchBarValue}
              currentTitle={currentTitle}
              pageLoading={pageLoading}
              renderedRows={renderedRows}
              page={page}
              rowsPerPage={rowsPerPage}
              setPageLoading={setPageLoading}
              navigate={navigate}
              groupTrees={groupTrees}
              selectedIndex={selectedIndex}
              setPage={setPage}
              setCurrentTitle={setCurrentTitle}
              setSelectedIndex={setSelectedIndex}
              setRenderedRows={setRenderedRows}
              editedparentsGroupsList={editedparentsGroupsList}
              setRowsPerPage={setRowsPerPage}
              siteBreadcrumbs={siteBreadcrumbs}
              setSiteBreadcrumbs={setSiteBreadcrumbs}
              setAddGroupDialogOpen={setAddGroupDialogOpen}
              navBarCollapsed={navBarCollapsed}
              permissions={permissions}
              selected={selected}
              setSelected={setSelected}
              setSiteScreenAlerts={setSiteScreenAlerts}
              setSiteScreenLoading={setSiteScreenLoading}
              setSearchBarValue={setSearchBarValue}
              setEditedParentGroupList={setEditedParentGroupList}
              setBackdropLoadingScreenOn={setBackdropLoadingScreenOn}
              editableGroupSelected={editableGroupSelected}
              setEditableGroupSelected={setEditableGroupSelected}
              selectedGroupListName={selectedGroupListName}
              setSelectedGroupListName={setSelectedGroupListName}
              setGroupTrees={setGroupTrees}
              getIndividualGroup={getIndividualGroup}
            />
          </div>
          <div className="absolute right-[14vw] top-[18px]">
            <OrangeTextButton
              onClick={() => {
                setSearchCamerasDialogOpen(true);
              }}
              text="Search Cameras"
              disabled={false}
            />
          </div>
          {permissions.add_cameras && (
            <div>
              <AddSiteButton navigate={navigate} />
            </div>
          )}
        </div>
      </div>
      <div className="justify-start">
        <NavBar
          navBarCollapsed={navBarCollapsed}
          setNavBarCollapsed={setNavBarCollapsed}
          props={{}}
        />
      </div>
    </div>
  );
};
